<div class="create-survey-wrapper w-full hidden sm:flex">
  <div class="form-wrapper w-full">
    <div class="py-0 px-0 sm:py-10 sm:px-8 w-full">
      <div class="general-information-content">
        {{surveyDetails?.title}}
      </div>
      <hr *ngIf="surveyDetails?.title"
          class="w-full separator">
      <div class="schedule-form-wrapper w-full flex justify-center">
        <div
          class="w-full flex flex-col sm:flex-row justify-between"
          id="surveyCreator"
        >
          <survey-creator [model]="surveyCreatorModel"></survey-creator>
        </div>
      </div>
    </div>
    <hr *ngIf="surveyCreatorModel?.JSON?.pages"
        class="w-full separator">
    <div
      class="schedule-form-wrapper md:flex-row flex-col w-full flex md:justify-between justify-center">
      <div class="md:w-[50%] w-full flex justify-start">
        <div class="w-full md:w-[30%] flex justify-start">
          <app-primary-button
            (click)="backButtonClicked()"
            *ngIf="surveyCreatorModel?.JSON?.pages"
            class="w-full"
            type="small">
            Back
          </app-primary-button>
        </div>
      </div>
      <div
        class="md:flex-row flex-col md:w-[50%] w-full flex md:justify-end justify-center">
        <div
          class="w-full md:w-[30%] flex justify-end md:ml-[1rem] ml-0 md:mt-0 mt-[1rem]">
          <app-primary-button (handleClick)="saveSurvey(false)"
                              *ngIf="surveyCreatorModel?.JSON?.pages"
                              [isDisabled]="!(surveyCreatorModel?.JSON?.pages && surveyCreatorModel?.JSON?.pages[0] && surveyCreatorModel?.JSON?.pages[0].elements?.length > 0)"
                              class="w-full"
                              type="small">Save
          </app-primary-button>
        </div>
        <div
          class="w-full md:w-[30%] flex justify-end md:ml-[1rem] ml-0 md:mt-0 mt-[1rem]">
          <app-primary-button
            (handleClick)="saveSurvey(true)"
            *ngIf="surveyCreatorModel?.JSON?.pages"
            [isDisabled]="!(surveyCreatorModel?.JSON?.pages && surveyCreatorModel?.JSON?.pages[0] && surveyCreatorModel?.JSON?.pages[0].elements?.length > 0)"
            class="w-full"
            type="small">Next
          </app-primary-button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="flex sm:hidden">
  <app-screen-size-alert [hyperLinkText]="'Go Back To Manage Questionnaires'"
                         navigationLink="/stanford-admin/questionnaires/manage-questionnaires"></app-screen-size-alert>
</div>
